import * as React from "react";
import PropTypes from "prop-types";
import IconBase from "./IconBase";

const SpotlightIcon = (props) => (
  <IconBase {...props} defaultPathColor="#333244" forceDefaultPath={true} />
);

SpotlightIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeColor: PropTypes.string,
  fillColor: PropTypes.string,
  pathColor: PropTypes.string,
};

export default SpotlightIcon;
